import angular from 'angular'
import template from './template.html'

angular.module('nominas.nomina')
  .component('nominaTimbresListaItemEstatus', {
    template: template,
    bindings: {
      estatus: '<',
      pendiente: '<',
    },
  })



// WEBPACK FOOTER //
// ./src/nominas/nomina/components/timbres/lista/item/estatus/component.js